/**
 * Application navigation views
 * Used in App.jsx for routing and view management
 * 
 * These constants prevent typos and provide autocompletion
 * for all available views in the application.
 */

export const APP_VIEWS = {
    LANDING: 'landing',
    LIST: 'list',
    SHARED_LIST: 'shared-list',
    SCAN: 'scan',
    LISTS: 'lists',
    BIBLIONAUTAS: 'biblionautas',
    BIBLIOVERSO: 'biblioverso',
    SETTINGS: 'settings',
    /** sonarjs/no-hardcoded-passwords: Correcting false positive. CHANGE_PASSWORD is a route identifier. */
    // eslint-disable-next-line sonarjs/no-hardcoded-passwords
    CHANGE_PASSWORD: 'change-password',
} as const

/**
 * Type for app view values
 */
export type AppView = (typeof APP_VIEWS)[keyof typeof APP_VIEWS]
